import { render, staticRenderFns } from "./FormTraditional.vue?vue&type=template&id=14058c40&"
import script from "./FormTraditional.vue?vue&type=script&lang=js&"
export * from "./FormTraditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports